import React from "react";
import { Phone, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BuiltToLastInIndiana() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  return <section id="built-to-last-in-indiana" className="relative min-h-screen w-full flex items-center overflow-hidden bg-background !justify-end !bg-[url(https://awaited-badger.10web.cloud/wp-content/uploads/2026/03/7.jpg)] !bg-[url(https://awaited-badger.10web.cloud/wp-content/uploads/2026/03/7.jpg)]">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-black/40 z-10 !bg-[url(https://awaited-badger.10web.cloud/wp-content/uploads/2026/03/Untitled-design-6.jpg)] !bg-[url(https://awaited-badger.10web.cloud/wp-content/uploads/2026/03/Untitled-design-7.jpg)] !bg-[url(https://awaited-badger.10web.cloud/wp-content/uploads/2026/03/Untitled-design-8.jpg)]" />
        <div className="w-full h-full bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1568171/img/stamped_concrete_driveway_hero.png)] bg-cover bg-bottom bg-fixed" />
      </div>

      {}
      <div className="container relative z-20 mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32">
        <div ref={textRef} className={`max-w-4xl transition-all duration-1000 ease-out ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {}
          <h1 className="font-serif text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black text-white leading-[0.9] tracking-tight mb-8 drop-shadow-lg">
            CONCRETE <br />
            BUILT TO LAST
          </h1>

          {}
          <div className="flex border-l-4 border-primary pl-6 md:pl-8 mb-10 backdrop-blur-sm bg-black/10 py-2 rounded-r-lg max-w-2xl">
            <p className="text-lg md:text-xl text-white/95 font-medium leading-relaxed max-w-2xl">
              Locally owned and serving Central & Northern Indiana with nearly 20 years of experience. 
              We deliver precision craftsmanship for residential and commercial projects that stand the test of time.
            </p>
          </div>

          {}
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6">
            <Button asChild size="lg" className="text-base font-bold px-8 py-6 h-auto shadow-xl hover:scale-105 transition-transform duration-300">
              <Link to="tel:317-709-9540">
                call to schedule a quote
              </Link>
            </Button>
            
            <Button asChild variant="ghost" size="lg" className="text-base font-bold px-8 py-6 h-auto text-white border-2 border-white/30 hover:bg-white hover:text-black hover:border-white transition-all duration-300 backdrop-blur-sm">
              
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-background to-transparent z-10" />
    </section>;
}